<template>
  <div
    class="modal fade"
    id="viewCertificate"
    tabindex="-1"
    role="dialog"
    aria-labelledby="viewCertificateLabel"
    aria-hidden="true"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div
      class="modal-dialog modal-xl modal-lgr modal-xxl"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header row mx-0 py-1">
          <div class="col col-sm-8">
            <h6
              class="modal-title font-weight-bolder"
              id="viewCertificateLabel"
            >
              View Certificate
            </h6>
          </div>
          <div class="col col-sm-4">
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-sm btn-outline-secondary font-weight-bolder ml-2 float-right"
            >
              Close
            </button>
          </div>
        </div>

        <div class="modal-body p-0 mx-auto">
          <iframe
            :src="`data:application/pdf;base64,${crewTrainingCertificateSrc}`"
            width="1440"
            height="630"
            v-if="crewTrainingCertificateSrc"
            frameborder="0"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: "ViewCertificate",

        computed: {
            ...mapGetters([ 'crewTrainingCertificateSrc' ])
        }
    }
</script>

<style scoped>

</style>
